import * as React from 'react';
import {Loading} from '@openfin/desktop-ui';

import * as Styles from './SearchMessage.module.scss';

export const SearchLoading: React.FunctionComponent = () => {
    return (
        <div className={Styles['search-message']}>
            <div className={Styles['message']}>
                <Loading />
            </div>
        </div>
    );
};
